import React from "react";
import { Link } from "react-router-dom";

const Privacy: React.FC = () => (
  <div className="page legal-page">
    <h1>Privacy Policy</h1>
    <p className="form-hint">Last updated: August 7, 2026 · Ticketed Wedding (Pash Company)</p>
    <div className="golden-thread" aria-hidden="true" />

    <div className="legal-body">
      <p>
        Ticketed Wedding (&quot;we&quot;, &quot;us&quot;) helps couples list weddings and guests
        RSVP or request tickets. This policy explains what we collect and how we use it.
      </p>

      <h2>Information we collect</h2>
      <ul>
        <li>Account email and authentication credentials</li>
        <li>Wedding listing details you publish (couple names, venue, photos, vibes)</li>
        <li>Guest list data you upload (names, emails, phone) — private to you as Thrower</li>
        <li>Goer profile preferences (dress, vibes, age confirmation, Instagram handle)</li>
        <li>Ticket requests, RSVP status, and payment metadata from Stripe</li>
      </ul>

      <h2>How we use information</h2>
      <ul>
        <li>To operate RSVP, Discovery, approval, and ticket purchase flows</li>
        <li>To show Goer profile details to Throwers only during pending approvals</li>
        <li>To send transactional email (invites, confirmations, approvals, reminders)</li>
        <li>To process payments through Stripe; we never store full card numbers</li>
      </ul>

      <h2>Sharing</h2>
      <p>
        We share data with service providers needed to run the product. Guest lists are not exposed on public wedding pages. Goer profiles are
        shared with a Thrower only in the context of a Public Seat request for their wedding.
      </p>

      <h2>Retention &amp; your choices</h2>
      <p>
        You may update Goer preferences in Profile. Throwers may edit or
        remove guest list entries. Contact us to request account deletion. Payment records
        may be retained as required for accounting and fraud prevention.
      </p>

      <h2>Contact</h2>
      <p>
        Questions or privacy requests:{" "}
        <a href="mailto:hello@ticketweddings.com">hello@ticketweddings.com</a>. See also
        our <Link to="/terms">Terms of Service</Link>.
      </p>
    </div>
  </div>
);

export default Privacy;
